import { useMemo } from 'react'
import { Spinner, Text, VisuallyHidden } from '@n26/nxd'
import { useDashboardStructure } from '@/features/dashboard/api/queries'
import { deepDiveLookup } from '@/features/dashboard/model/sections'
import { SectionGroup } from '@/features/dashboard/tiles/SectionGroup'
import styles from './DashboardPage.module.css'

export const DashboardPage = () => {
  const { data: dashboard, isPending, isError } = useDashboardStructure()
  const deepDiveOf = useMemo(
    () => deepDiveLookup(dashboard?.sections ?? []),
    [dashboard?.sections]
  )

  if (isPending) {
    return (
      <div className={styles.status} role='status'>
        <Spinner />
        <VisuallyHidden>Loading</VisuallyHidden>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={styles.status} role='alert'>
        <Text color='rhubarb'>Couldn&apos;t load the dashboard.</Text>
      </div>
    )
  }

  // Deep dives aren't shown on the home page: a card opens the deep dive the
  // backend links it to, else the first that features it, from its expanded view.
  return (
    <div className={styles.page}>
      {dashboard.sections
        .filter(section => section.kind === 'section')
        .map(section => (
          <SectionGroup
            key={section.id}
            section={section}
            deepDiveOf={deepDiveOf}
          />
        ))}
    </div>
  )
}
